export default __webpack_public_path__ + "static/media/undraw_page_not_found_su7k.1db847eb.svg";